"use client";
export{l as Mermaid}from'./chunk-BO2N2NFS.js';